import { useEffect, useState } from "react";
import DateRangePicker from '../general/form-control/date-rangepicker';
import moment from "moment";

const SelectInput = ({ label,id,onValueChange }:any) => {

    const onDateChange = ({ id, timestamp }: any) => {
        let cdate = '';
        if (timestamp) {
            cdate = moment(timestamp, 'DD-MM-YYYY').format('YYYY-MM-DD');
        }
      //  console.log("onDateChange ",id,cdate)
        onValueChange(id, cdate);
    };

    return (
        <div className="col-xxxxl-12 col-xl-12 col-lg-12 col-md-12 col-12">
            {' '}
            <div className="input-container sideFilter">
                <div className="label">Order Date </div>
                <DateRangePicker
                    onDateChange={(obj: any) => onDateChange(obj)}
                />
            </div>
        </div>
    );
}

export default SelectInput;